/**
 * Tax – VAT Payment
 */

export default {
  vatPayment: {
    q1: "1 quarter",
    q2: "2 quarter",
    q3: "3 quarter",
    q4: "4 quarter",
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    june: "June",
    july: "July",
    aug: "August",
    sept: "September",
    oct: "October",
    nov: "November",
    dec: "December",
    eur: "EUR",
    usd: "USD",
    gbr: "GBP",
    vatRet: "VAT Returns",
    orderVP: "Order VAT payment",
    vatPaymentForm: "VAT Payment form",
    fillParam:
      "Fill your payment parameters a commission for payment is 50 Eur. Upon submitted form you will receive a Request of funds. If requested currency changes from currency of chosen country additional charges may apply.",
    addVatRegData: "Please add your VAT registration data",
    here: "here",
    paymentCurr: "Payment currency",
    paymentCurrLC: "payment currency",
    payment: "Payment",
    ok: "Ok",
    thankForReq:
      "Thank you for your request! You will be emailed with the invoice and further instructions within several hours.",
    country: "Country",
    year: "Year",
    vatSum: "VAT amount",
    period: "Period",
    order: "Order",
    wantReq: "I want a Request of funds in another currency",
    vatPayment: "VAT payment",
  },
};
